module.exports = __webpack_public_path__ + "static/img/PC-8.9668f0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcyixuekao/PC-8.png
// module id = GVtB
// module chunks = 0